import React from 'react';
interface WorkiumLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
}
export function WorkiumLogo({
  size = 'md',
  showWordmark = true
}: WorkiumLogoProps) {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12'
  };
  const textClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl'
  };
  return <div className="flex items-center gap-2.5" data-id="element-303">
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${sizeClasses[size]} aspect-square flex-shrink-0`} aria-hidden="true" data-id="element-304">
        <defs data-id="element-305">
          <linearGradient id="hubGradient" x1="14.5" y1="14.5" x2="25.5" y2="25.5" gradientUnits="userSpaceOnUse" data-id="element-306">
            <stop stopColor="#A5B4FC" data-id="element-307" />
            <stop offset="1" stopColor="#6366F1" data-id="element-308" />
          </linearGradient>
          <linearGradient id="ringGradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse" data-id="element-309">
            <stop stopColor="#4F46E5" stopOpacity="0.2" data-id="element-310" />
            <stop offset="0.5" stopColor="#38BDF8" stopOpacity="0.5" data-id="element-311" />
            <stop offset="1" stopColor="#C084FC" stopOpacity="0.2" data-id="element-312" />
          </linearGradient>
        </defs>

        {/* Orbit Ring */}
        <circle cx="20" cy="20" r="18" stroke="url(#ringGradient)" strokeWidth="1" strokeDasharray="4 4" className="origin-center animate-spin-slow" data-id="element-313" />

        {/* Connecting Lines */}
        <path d="M20 20 L20 6" stroke="#A5B4FC" strokeWidth="1.5" strokeOpacity="0.5" data-id="element-314" />
        <path d="M20 20 L32.1 27" stroke="#7DD3FC" strokeWidth="1.5" strokeOpacity="0.5" data-id="element-315" />
        <path d="M20 20 L7.9 27" stroke="#C4B5FD" strokeWidth="1.5" strokeOpacity="0.5" data-id="element-316" />

        {/* Center Hub */}
        <circle cx="20" cy="20" r="5.5" fill="url(#hubGradient)" data-id="element-317" />

        {/* Satellites */}
        <circle cx="20" cy="6" r="2.5" fill="#A5B4FC" className="origin-[20px_6px] animate-pulse-node" data-id="element-318" />
        <circle cx="32.1" cy="27" r="2.5" fill="#7DD3FC" className="origin-[32.1px_27px] animate-pulse-node delay-300" data-id="element-319" />
        <circle cx="7.9" cy="27" r="2.5" fill="#C4B5FD" className="origin-[7.9px_27px] animate-pulse-node delay-700" data-id="element-320" />
      </svg>

      {showWordmark && <span className={`font-extrabold tracking-[-0.02em] text-white ${textClasses[size]}`} data-id="element-321">
          Workium AI<span className="text-indigo-400" data-id="element-322">.</span>
        </span>}
    </div>;
}